import keycloakAxios from '@/services/axios';

export const fetchCompanies = async () => {
  const response = await keycloakAxios.post('admin/company/companies');

  if (response.status === 300) {
    throw new Error(
      `Error fetching companies: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
